type MeetingInvitationDetails = {
  createdById?: string | number
  invitedUserIds?: Array<string | number>
}

export const isCurrentUserMeetingParticipant = (
  event: MeetingInvitationDetails | null | undefined,
  currentUserId: string | number | null | undefined,
) => {
  if (!event || currentUserId === null || currentUserId === undefined) return false

  const normalizedUserId = String(currentUserId)
  if (event.createdById !== undefined && String(event.createdById) === normalizedUserId) return true

  return (event.invitedUserIds || []).some((userId) => String(userId) === normalizedUserId)
}
